import axios from './../app/axiosInterceptorMotorbikeAPI';

export function getInformationFromMotorbikeAPI() {
    return axios({
        method: 'get',
        url: 'motorbikes/get-all',
    });
}
